// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.part-detail-container {
  height: 400px;
}
.imagemagnify-wrapper {
  max-height: 350px;
  object-fit: cover;
}

.tab-section {
  margin: 10px;
}

.tab-button {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: rgb(30, 65, 72);
  border-radius: 0.25rem;
  text-decoration: none;
  border: 1px solid rgb(222, 228, 228);
  text-align: center;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
}
.tab-text {
  color: lightgray !important;
  pointer-events: none;
}

.tab-button:hover,
.active {
  color: #2563eb;
}

.left-panel {
  flex: 1 1;
  overflow: auto;
  height: 550px;
}

.left-panel-mob {
  flex: 1 1;
}

.right-panel {
  flex: 1 1;
  padding: 0px 10px;
  height: 550px;
}

.column-flex {
  flex-direction: column;
  margin-bottom: 20px;
}

.row-flex {
  display: flex;
  margin-bottom: 20px;
}

.menu-toggle {
  display: none;
  font-size: 11px;
  background: none;
  border: none;
  cursor: pointer;
}

.mob-menu {
  display: flex;
  flex-direction: column;
  font-size: 11px;
  background-color: #001489;
  color: #ffcc00;
  width: 50%;
}

.divider {
  border-bottom: 1px solid hsl(240, 5.9%, 90%);
}

.sub-text {
  color: #000;
  word-break: "normal";
  text-align: "left";
  margin-left: 10px;
  font-size: 12px;
}

.text-xl {
  font-size: 1.25rem;
  font-weight: 700;
}
.image-style {
  width: 60%;
  cursor: pointer;
  margin-left: 20%;
  align-content: center;
  padding: 10px;
}
.image-layout {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.option-image-style {
  width: 70px;
  cursor: pointer;
  margin: 10px;
  border-radius: 5px;
  padding: 4px;
}
.bottom-btn-wrapper {
  display: flex;
  float: right;
}
.reference-text-wrapper {
  display: flex;
  margin-bottom: 20px;
  font-size: 11px;
  border-top: 1px solid grey;
}
.applications-link-style {
  display: flex;
  justify-content: center;
  margin-top: 5px;
  gap: 20px;
}

@media only screen and (min-width: 1023px) and (max-width: 2560px) {
  .tab-section {
    display: block;
  }
  .right-panel {
    height: 550px;
  }
  .left-panel {
    height: 550px;
  }
  .part-detail-container {
    height: 450px;
  }
}

@media only screen and (min-width: 767px) and (max-width: 1023px) {
  .tab-section {
    display: none;
  }
  .right-panel {
    height: 520px;
  }
  .left-panel {
    height: 520px;
  }
  .part-detail-container {
    height: 400px;
  }
  .image-style {
    width: 40%;
    margin-left: 25%;
  }
}

@media only screen and (max-width: 600px) {
  .tab-section {
    display: none;
  }

  .menu-toggle {
    display: block;
  }

  .right-panel {
    margin-top: 15px;
    padding: 0px;
    height: 400px;
  }
  .part-detail-container {
    height: 310px;
  }
  .image-style {
    width: 80%;
    margin-left: 10%;
  }
}

.custom-table-header > th {
  height: 35px !important;
}
.application-list-text-wrapper {
  margin-bottom: 40px;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/partDetails/PartDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".part-detail-container {\n  height: 400px;\n}\n.imagemagnify-wrapper {\n  max-height: 350px;\n  object-fit: cover;\n}\n\n.tab-section {\n  margin: 10px;\n}\n\n.tab-button {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.5;\n  color: rgb(30, 65, 72);\n  border-radius: 0.25rem;\n  text-decoration: none;\n  border: 1px solid rgb(222, 228, 228);\n  text-align: center;\n  cursor: pointer;\n  padding: 0.5rem 0.75rem;\n}\n.tab-text {\n  color: lightgray !important;\n  pointer-events: none;\n}\n\n.tab-button:hover,\n.active {\n  color: #2563eb;\n}\n\n.left-panel {\n  flex: 1;\n  overflow: auto;\n  height: 550px;\n}\n\n.left-panel-mob {\n  flex: 1;\n}\n\n.right-panel {\n  flex: 1;\n  padding: 0px 10px;\n  height: 550px;\n}\n\n.column-flex {\n  flex-direction: column;\n  margin-bottom: 20px;\n}\n\n.row-flex {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.menu-toggle {\n  display: none;\n  font-size: 11px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.mob-menu {\n  display: flex;\n  flex-direction: column;\n  font-size: 11px;\n  background-color: #001489;\n  color: #ffcc00;\n  width: 50%;\n}\n\n.divider {\n  border-bottom: 1px solid hsl(240, 5.9%, 90%);\n}\n\n.sub-text {\n  color: #000;\n  word-break: \"normal\";\n  text-align: \"left\";\n  margin-left: 10px;\n  font-size: 12px;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n.image-style {\n  width: 60%;\n  cursor: pointer;\n  margin-left: 20%;\n  align-content: center;\n  padding: 10px;\n}\n.image-layout {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.option-image-style {\n  width: 70px;\n  cursor: pointer;\n  margin: 10px;\n  border-radius: 5px;\n  padding: 4px;\n}\n.bottom-btn-wrapper {\n  display: flex;\n  float: right;\n}\n.reference-text-wrapper {\n  display: flex;\n  margin-bottom: 20px;\n  font-size: 11px;\n  border-top: 1px solid grey;\n}\n.applications-link-style {\n  display: flex;\n  justify-content: center;\n  margin-top: 5px;\n  gap: 20px;\n}\n\n@media only screen and (min-width: 1023px) and (max-width: 2560px) {\n  .tab-section {\n    display: block;\n  }\n  .right-panel {\n    height: 550px;\n  }\n  .left-panel {\n    height: 550px;\n  }\n  .part-detail-container {\n    height: 450px;\n  }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 1023px) {\n  .tab-section {\n    display: none;\n  }\n  .right-panel {\n    height: 520px;\n  }\n  .left-panel {\n    height: 520px;\n  }\n  .part-detail-container {\n    height: 400px;\n  }\n  .image-style {\n    width: 40%;\n    margin-left: 25%;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .tab-section {\n    display: none;\n  }\n\n  .menu-toggle {\n    display: block;\n  }\n\n  .right-panel {\n    margin-top: 15px;\n    padding: 0px;\n    height: 400px;\n  }\n  .part-detail-container {\n    height: 310px;\n  }\n  .image-style {\n    width: 80%;\n    margin-left: 10%;\n  }\n}\n\n.custom-table-header > th {\n  height: 35px !important;\n}\n.application-list-text-wrapper {\n  margin-bottom: 40px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
